import script from "./ClientFeedbackFormView.vue?vue&type=script&setup=true&lang=js"
export * from "./ClientFeedbackFormView.vue?vue&type=script&setup=true&lang=js"

import "./ClientFeedbackFormView.vue?vue&type=style&index=0&id=12a6c814&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12a6c814"]])

export default __exports__